import { ICompanyProductViewModel } from 'Interfaces/ICompanyProductConfig';
import { IProductViewModel } from 'Interfaces/IProductConfig';
import { TicketProductViewInterface } from './TicketStyleConfig';

export interface ITicketProductState {
  consumableProducts: IProductViewModel[];
  investmentProducts: IProductViewModel[];
  agreementProducts: ICompanyProductViewModel[];
  serviceProducts: ICompanyProductViewModel[];
  ticketProducts: TicketProductViewInterface[];
}

export const TicketProductState: ITicketProductState = {
  consumableProducts: [],
  investmentProducts: [],
  agreementProducts: [],
  serviceProducts: [],
  ticketProducts: [],
};

// Definer handlingstyper
export type Action =
  | { type: 'SET_CONSUMABLE_PRODUCTS'; payload: IProductViewModel[] }
  | { type: 'SET_INVESTMENT_PRODUCTS'; payload: IProductViewModel[] }
  | { type: 'SET_AGREEMENT_PRODUCTS'; payload: ICompanyProductViewModel[] }
  | { type: 'SET_SERVICE_PRODUCTS'; payload: ICompanyProductViewModel[] }
  | { type: 'SET_TICKET_PRODUCTS'; payload: TicketProductViewInterface[] };

// Reducer-funksjonen
export const TicketProductReducer = (
  state: ITicketProductState = TicketProductState,
  action: Action
): ITicketProductState => {
  switch (action.type) {
    case 'SET_CONSUMABLE_PRODUCTS':
      return {
        ...state,
        consumableProducts: action.payload,
      };
    case 'SET_INVESTMENT_PRODUCTS':
      return {
        ...state,
        investmentProducts: action.payload,
      };
    case 'SET_AGREEMENT_PRODUCTS':
      return {
        ...state,
        agreementProducts: action.payload,
      };
    case 'SET_SERVICE_PRODUCTS':
      return {
        ...state,
        serviceProducts: action.payload,
      };
    case 'SET_TICKET_PRODUCTS':
      return {
        ...state,
        ticketProducts: action.payload,
      };
    default:
      return state;
  }
};
